import { render, staticRenderFns } from "./simple-slide-toggle.vue?vue&type=template&id=e2b2a1ea&"
import script from "./simple-slide-toggle.vue?vue&type=script&lang=ts&"
export * from "./simple-slide-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./simple-slide-toggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports